import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';
import { Box, Flex, Text, Divider, 
  // Select 
} from '@chakra-ui/react';

const RoundedBar = (props) => {
  const { x, y, width, height } = props;
  const radius = 9; 
  return (
    <g>
      <path d={`M${x},${y + height} L${x},${y + radius} Q${x},${y} ${x + radius},${y} L${x + width - radius},${y} 
        Q${x + width},${y} ${x + width},${y + radius} L${x + width},${y + height} Z`} fill={props.fill} />
    </g>
  );
};

const formatYAxis = (tickValue) => {
  return tickValue !== 0 ? tickValue + 'k' : tickValue;
};

const DashboardProgrammeReport = ({ barChartData = [], title, color1, color2, text1, text2 , others=false}) => {
  // const [selectedYear, setSelectedYear] = React.useState("This Year");

  const filteredData = barChartData || [];

  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", 
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

const formattedData = filteredData.map(item => ({
...item,
month: monthNames[item.month - 1]
}));


  return (
    <Flex direction="column" alignItems="flex-start" bg={'#FFFFFF'} borderRadius={'20px'} pr={3}>
      <Flex py={3} pl={5} justifyContent={'space-between'} alignItems={'center'} w={'100%'}>
        <Text fontSize={'14px'} fontWeight={'500'} letterSpacing={'-0.154px'} color={'#D73439'}>
          { title ? title : "Total Members That Attended Programmes"}
        </Text>
      </Flex>
      <Flex w="100%" direction={['column', 'column', 'row']} py={4} alignItems={'center'}>
        <ResponsiveContainer width="100%" height={280}>
        <BarChart data={formattedData} margin={{ top: 20, right: 10, left: 10, bottom: 5 }}>
            <XAxis dataKey="month" axisLine={false} tickLine={false} />
            <YAxis axisLine={false} tickLine={false} tickFormatter={formatYAxis} />
            <Tooltip />
            <Bar dataKey={others ? "successfulCount" : "membersPresent"} shape={<RoundedBar />} fill={ color1 ? color1 : "D11A2A"} barSize={15} />
            <Bar dataKey={others ? "failedCount" : "memebersAbsent"} shape={<RoundedBar />} fill={ color2 ? color2 : "#D7343930"} barSize={15} />
          </BarChart>
        </ResponsiveContainer>
        <Divider orientation="vertical" border={'1px solid #E4E5E7'} mr={2} h={"90%"} />
        <Flex direction="column" justify="center">
          <Flex alignItems={'center'} gap={2}>
            <Box bg={ color1 ? color1 :"#D11A2A"} h={2} w={4} borderRadius="3px"></Box>
            <Text fontSize="sm" color="#4D4D4D">{text1 ? text1 : "Present"}</Text>
          </Flex>
          <Flex alignItems={'center'} gap={2}>
            <Box bg={ color2 ? color2 :"#D7343930"} h={2} w={4} borderRadius="3px"></Box>
            <Text fontSize="sm" color="#4D4D4D">{ text2 ? text2 : "Absent "}</Text>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default DashboardProgrammeReport;
